const defaultDepositOptions = [25, 50, 100, 200];
const isCustomDeposit = (depositAmount) => !defaultDepositOptions.includes(depositAmount);

export { isCustomDeposit };
